import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initializeFirebase } from "./initialize";
import { UserProvider } from "./providers/UserContext";
import {BrowserRouter as Router} from 'react-router-dom';
import {InboxProvider} from "./providers/InboxProvider";
import {ChatListProvider} from "./providers/ChatListProvider";
import {ModalProvider} from "./providers/ModalProvider";
import {LayoutProvider} from "./providers/LayoutProvider";
import PWAInstallButton from "./components/common/PWAInstallButton";
import {initMessaging} from "./lib/utils/messaging";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
if ("setAppBadge" in navigator && navigator.setAppBadge) {
  navigator.setAppBadge(1).catch((error) => {
    console.error("Failed to set badge:", error);
  });
}
initializeFirebase();
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch((error) => console.error("Service Worker registration failed:", error));
}
root.render(
    <UserProvider>
      <InboxProvider>
        <LayoutProvider>
          <ChatListProvider>
            <ModalProvider>
              <Router>
                <App />
                <PWAInstallButton />
              </Router>
            </ModalProvider>
          </ChatListProvider>
        </LayoutProvider>
      </InboxProvider>
    </UserProvider>
);

